import React, { useState, useEffect, useRef } from "react";
import { ThreeDots } from "react-loader-spinner";
import "../../Pages/Admin/Style.css";
import "./add_subcategories.css";
import Select from "react-select";
function Add_InstructorSub_Categories({ onClose }) {
  const [
    modalAdd_InstructorSub_CategoriesIsOpen,
    setAdd_InstructorSub_CategoriesModalIsOpen,
  ] = useState("");
  // const [partnerName, setPartnerName] = useState("");
  // const [email, setEmail] = useState("");
  // const [link, setLink] = useState("");
  // const [file, setIconFile] = useState();
  const [
    isAddingInstructorSub_Categories,
    setIsAddingInstructorSub_Categories,
  ] = useState(false);

  const closeAdd_InstructorSub_Categories = () => {
    setAdd_InstructorSub_CategoriesModalIsOpen(false);
  };
  const Status = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ];
  const homepage = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];

  function reloadPage() {
    window.location.reload();
  }

  return (
    <div>
      {modalAdd_InstructorSub_CategoriesIsOpen && (
        <Add_InstructorSub_Categories
          onClose={closeAdd_InstructorSub_Categories}
        />
      )}
      <div className="popup-background">
        <div className="popup">
          <div
            class="modal-content"
            style={{
              width: "75%",
              height: "80%",
              padding: "2%",
              backgroundColor: "#fff",
              borderRadius: "5px",
              // overflowY:'scroll'
            }}
          >
            <div
              class="modal-header"
              style={{
                width: "100%",
                marginBottom: "3%",
                borderBottom: "solid 1px #7e7a7a8c",
              }}
            >
              <h5
                class="modal-title"
                id="modalAddTitle"
                style={{ marginBottom: "2%" }}
              >
                <b>Add Sub-categories</b>
              </h5>

              <button
                type="button"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div
              class="modal-body"
              style={{ overflowY: "scroll", padding: "2%" }}
            >
              <form>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Name<font color="red"></font>
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    placeholder=""
                  />
                </div>

                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Description
                  </label>
                  <textarea type="text" id="selectedImg" class="form-control" />
                </div>

                <div class="form-group" style={{ display: "block" }}>
                  <label class="small mb-1" for="inputFullName">
                    Category Tag
                  </label>
                  <br></br>
                  <input
                    style={{ marginRight: "8px" }}
                    type="checkbox"
                    name="category"
                    value="workshop"
                  ></input>
                  Workshop
                  <input
                    style={{
                      marginLeft: "8px",
                      marginRight: "8px",
                      fontSize: "20px",
                    }}
                    type="checkbox"
                    name="category"
                    value="venue"
                  ></input>
                  Venue
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Category <font color="red"></font>
                  </label>
                  <Select options={Status}></Select>
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Status <font color="red"></font>
                  </label>
                  <Select options={Status}></Select>
                </div>
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Show on Home Page?: <font color="red"></font>
                  </label>
                  <Select options={homepage}></Select>
                </div>
              </form>
            </div>

            <div
              class="modal-footer"
              style={{
                padding: "2%",
                marginTop: "3%",
                borderTop: "solid 1px #7e7a7a8c",
              }}
            >
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
              >
                Close
              </button>
              {isAddingInstructorSub_Categories === true ? (
                <div>
                  <ThreeDots color="#000" height={50} width={50} />
                </div>
              ) : (
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary "
                  style={{ background: "#000 ", border: "none" }}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Add_InstructorSub_Categories;
